module.exports = __webpack_public_path__ + "media/images/undraw/matching/meet_the_team-bb7ea47c1fee561a81dc0c96fae0ade0.png";